import { defineComponent } from "@vue/composition-api";
import { CreateElement, RenderContext, VNode } from "vue";
import { Location } from "vue-router";
import BaseTitle from "@/components/BaseTitle";
import GoBack from "@/components/GoBack";

type Props = {
  hideBack: string;
  icon: string;
  defaultBack: Location | null;
  rightIcon: boolean;
};

export default defineComponent({
  name: "PageTitle",
  functional: true,
  props: {
    hideBack: { type: Boolean, default: false },
    icon: { type: String, default: "sci-chevron-left" },
    defaultBack: { type: Object as () => Location | null },
    rightIcon: { type: Boolean, default: false },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const goBack = h(
      GoBack,
      {
        class: ["page-title__icon", ctx.props.rightIcon ? "__right" : undefined],
        props: { defaultRoute: ctx.props.defaultBack },
        on: ctx.listeners.click ? { click: ctx.listeners.click } : {},
      },
      [ctx.props.icon]
    );
    const baseTitle = h(BaseTitle, { staticClass: "f-grow-1 d-flex" }, [
      ctx.scopedSlots.default && ctx.scopedSlots.default({}),
    ]);
    const appendSlot = ctx.scopedSlots["append"] && ctx.scopedSlots["append"]({});
    const pageMenuTemplate = h("div", { class: "ml-auto" }, [
      ctx.scopedSlots["page-menu"] && ctx.scopedSlots["page-menu"]({}),
    ]);

    return h(
      "div",
      {
        staticClass: "page-title",
        class: [...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]), ctx.data.staticClass],
      },
      [!ctx.props.hideBack && goBack, baseTitle, appendSlot, ctx.scopedSlots["page-menu"] && pageMenuTemplate]
    );
  },
});
